export const getDisabledMenuNavbar = (accessLevel: any) => {
    let disableUMKD = true, disableEnterRatings = true, disableStudentPortfolio = true, disableSettings = true, disableRPD = true

    accessLevel.forEach((i: any) => {
        switch (i.accessLevelID) {
            case 1: disableUMKD = false; break
            case 2: disableEnterRatings = false; break
            case 3: disableStudentPortfolio = false; break
            case 4: disableSettings = false; break
            case 5: disableRPD = false; break

            default: break
        }
    })

    return { disableUMKD, disableEnterRatings, disableStudentPortfolio, disableSettings, disableRPD }
}